import { ReferenceRenderer } from './ReferenceRenderer';

export const ReferenceRendererModule = {
    __init__: ['referenceRenderer'],
    referenceRenderer: ['type', ReferenceRenderer],
};
